import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, Box } from '@mui/material';

/**
 * Filtro popup per AppDocuVehiclesPage
 * props:
 *   open: boolean
 *   onClose: function
 *   onApply: function({ document: 'all'|'with'|'without', package: 'all'|'with'|'without', calibration: 'all'|'with'|'without' })
 *   initial: { document, package, calibration }
 */
export default function ActionFiltersDialog({ open, onClose, onApply, initial }) {
  const [document, setDocument] = React.useState(initial?.document || 'all');
  const [pkg, setPkg] = React.useState(initial?.package || 'all');
  const [calibration, setCalibration] = React.useState(initial?.calibration || 'all');
  const [image, setImage] = React.useState(initial?.image || 'all');

  React.useEffect(() => {
    setDocument(initial?.document || 'all');
    setPkg(initial?.package || 'all');
    setCalibration(initial?.calibration || 'all');
    setImage(initial?.image || 'all');
  }, [initial, open]);

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Filtro Avanzato Azioni</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <FormControl>
            <FormLabel>Documenti associati</FormLabel>
            <RadioGroup row value={document} onChange={e => setDocument(e.target.value)}>
              <FormControlLabel value="all" control={<Radio />} label="ANY" />
              <FormControlLabel value="with" control={<Radio />} label="1+" />
              <FormControlLabel value="without" control={<Radio />} label="NONE" />
            </RadioGroup>
          </FormControl>
          <FormControl>
            <FormLabel>Packet associati</FormLabel>
            <RadioGroup row value={pkg} onChange={e => setPkg(e.target.value)}>
              <FormControlLabel value="all" control={<Radio />} label="ANY" />
              <FormControlLabel value="with" control={<Radio />} label="1+" />
              <FormControlLabel value="without" control={<Radio />} label="NONE" />
            </RadioGroup>
          </FormControl>
          <FormControl>
            <FormLabel>Calibrazioni associate</FormLabel>
            <RadioGroup row value={calibration} onChange={e => setCalibration(e.target.value)}>
              <FormControlLabel value="all" control={<Radio />} label="ANY" />
              <FormControlLabel value="with" control={<Radio />} label="1+" />
              <FormControlLabel value="without" control={<Radio />} label="NONE" />
            </RadioGroup>
          </FormControl>
          <FormControl>
            <FormLabel>Immagine</FormLabel>
            <RadioGroup row value={image} onChange={e => setImage(e.target.value)}>
              <FormControlLabel value="all" control={<Radio />} label="ANY" />
              <FormControlLabel value="with" control={<Radio />} label="YES" />
              <FormControlLabel value="without" control={<Radio />} label="NO" />
            </RadioGroup>
          </FormControl>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={() => onApply({ document, package: pkg, calibration, image })} variant="contained">Apply</Button>
      </DialogActions>
    </Dialog>
  );
}
